const SET_EXTRA = 'mrCollection/SET_EXTRA';
const SET_EXTRAS = 'mrCollection/SET_EXTRAS';

export default {
  // CHANGE_VALUES,

  SET_EXTRA,
  SET_EXTRAS,
};
